// Photographs for the chooser's answers, one per option: step → answer → picture. An answer
// with no photo here falls back to its line drawing (components/shop/LockPictos). Hugh is
// photographing the rest (17 Sep 2026): save each as public/images/shop/chooser/<file>.jpg
// with a 600 px "-sm" copy and add it here. Manufacturer or our own photos only.
// `pos` is the CSS object-position for the crop when the picture is wider than the card.
const chooserMedia = {
  slides: {
    slides: { src: '/images/shop/chooser/slides.jpg', sm: '/images/shop/chooser/slides-sm.jpg', alt: 'Aluminium sliding door open onto a deck', pos: '72% 50%' },
    swings: { src: '/images/shop/chooser/swings.jpg', sm: '/images/shop/chooser/swings-sm.jpg', alt: 'Timber hinged front door' },
  },
  material: {},
  sheltered: {},
  opens: {},
  onDoor: {},
  onSlider: {},
};

const mediaFor = (step, value) => (chooserMedia[step] && chooserMedia[step][value]) || null;

module.exports = { chooserMedia, mediaFor };
